import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getGeometrySelection } from "../../ducks/geometrySelection/selectors";

import { GeometrySelectionState, setGeometrySelection } from "../../ducks/geometrySelection/geometrySelection";

type UseGeometrySelection = [GeometrySelectionState, (state: GeometrySelectionState) => void];

export const useGeometrySelection = (): UseGeometrySelection => {
  const dispatch = useDispatch();
  const geometrySelection = useSelector(getGeometrySelection);

  const updateGeometrySelection = useCallback(
    (state: GeometrySelectionState) => {
      dispatch(setGeometrySelection(state));
    },
    [dispatch],
  );

  return [geometrySelection, updateGeometrySelection];
};
